import { Module } from '../Module';

/**
* This class is used as a façade for react components to communicate back with the angular world.
*/
export class AngularContext {

  constructor(
    private $scope: ng.IScope,
    private $injector: ng.auto.IInjectorService,
    private $compile: ng.ICompileService) {}

  public compileElement(element: JQuery, setupScope?: ($scope: ng.IScope) => ng.IScope): JQuery {
    const $scope = setupScope ? setupScope(this.$scope) : this.$scope;
    this.$compile(element)($scope);

    return element;
  }

  public get scope(): ng.IScope {
    return this.$scope;
  }

  public getService(name: string): any {
    return this.$injector.get(name);
  }

  public enqueueDigest(): void {
    // we can't call $digest directly because we might already be in a digest cycle and that would cause angular to throw.
    // instead, schedule another digest to run later.
    this.$scope.$evalAsync(angular.noop);
  }

  public evalAsync(fn: () => any): void {
    this.$scope.$evalAsync(fn);
  }
}

export interface AngularContextFactory {
  create($scope: ng.IScope): AngularContext;
}

Module.instance().factory(
  'AngularContextFactory',
  ['$injector', '$compile',
  ($injector: ng.auto.IInjectorService, $compile: ng.ICompileService): AngularContextFactory => {
    return {
      create: ($scope: ng.IScope): AngularContext => new AngularContext($scope, $injector, $compile)
    };
}]);
